import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'

import DirectoryDesktopView from './components/DirectoryDesktopView'
import {
	loadContentAssets,
	setDirectoryFilterState
} from '../../store/contentDirectory/contentDirectoryActions'
import { loadCategories } from '../../store/contentAssetCategories/contentAssetCategoriesActions'
import { loadTags } from '../../store/contentAssetTags/contentAssetTagsActions'
import { toSafeObject } from '../../store/helpers/StateHelper'
import { parseDirectoryUrl } from './UrlState'

/**
 * URL is the source of truth for filter / pagination / view state. This
 * component:
 *   1. Parses `location.search` on mount and whenever it changes.
 *   2. Mirrors the parsed values into the reducer so the sidebar/tag-bar
 *      highlights stay in sync without waiting for the list refetch.
 *   3. Dispatches the list thunk with the parsed params.
 *
 * Side effect: also lazy-loads categories + tags once per session (their
 * thunks already short-circuit when `loaded` is true).
 */
const Index = () => {
	const dispatch = useDispatch()
	const history = useHistory()
	const location = useLocation()

	const userProfile = useSelector((state) => toSafeObject(state.session.get('profile')))

	useEffect(() => {
		dispatch(loadCategories())
		dispatch(loadTags())
	}, [dispatch])

	useEffect(() => {
		const parsed = parseDirectoryUrl(location.search)
		dispatch(
			setDirectoryFilterState({
				selectedCategoryId: parsed.categoryId,
				selectedTagIds: parsed.tagIds,
				gridMode: parsed.gridMode
			})
		)
		dispatch(loadContentAssets(parsed.query, parsed.pageNumber, undefined, parsed.categoryId, parsed.tagIds))
	}, [dispatch, location.search])

	const onChangeLocation = (target) => history.push(target)

	return <DirectoryDesktopView userProfile={userProfile} onChangeLocation={onChangeLocation} />
}

export default Index
